module.exports = __WEBPACK_EXTERNAL_MODULE_3__;


/*****************
 ** WEBPACK FOOTER
 ** external {"commonjs":"react","commonjs2":"react","amd":"react","root":"React"}
 ** module id = 3
 ** module chunks = 0
 **/